import { forwardRef, type ComponentProps } from 'react'

import { markdownRootProps } from '../root-props'
import type { MarkdownProps } from '../index'

type ProseProps = ComponentProps<'div'> & Pick<MarkdownProps, 'size' | 'ladder' | 'measure'>

/**
 * A container with the markdown styles and nothing else, for HTML or React children you already
 * have: what `Markdown` renders its output into, without parsing anything.
 */
const Prose = forwardRef<HTMLDivElement, ProseProps>(function Prose(
  { size, ladder, measure, className, children, ...props },
  ref,
) {
  return (
    <div ref={ref} {...props} {...markdownRootProps({ size, ladder, measure, className })}>
      {children}
    </div>
  )
})

Prose.displayName = 'Markdown.Prose'

export { Prose }
export type { ProseProps }
